import { render, staticRenderFns } from "./previewArticle.vue?vue&type=template&id=163e89c4&scoped=true&"
import script from "./previewArticle.vue?vue&type=script&lang=js&"
export * from "./previewArticle.vue?vue&type=script&lang=js&"
import style0 from "./previewArticle.vue?vue&type=style&index=0&id=163e89c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e89c4",
  null
  
)

export default component.exports